import { useEffect } from "react";
import { Modal } from 'antd';

const GoogleSignErrorModal = ({ title, url, content, accessToken }) => {
  useEffect(() => {
    const gotoLoginPage = async () => {
      try {
        const response = await fetch(`https://oauth2.googleapis.com/revoke?token=${accessToken}`, {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
    
        if (!response.ok) {
          throw new Error('Failed to revoke Google auth token');
        }
        
        window.location.href=url;
    
      } catch (error) {
        console.error('Error revoking Google auth token:', error);
      }
    };

    Modal.warning({
      title: title,
      content: content,
      okText: 'Go to Login',
      onOk: gotoLoginPage,
    });
  }, [title, content, url, accessToken]);

  return null;
};

export default GoogleSignErrorModal;
